// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__agVjC","label":"CategoryService_label__No5Je","location":"CategoryService_location__KVXZh"};